import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import spIcon from "../../assets/brand/swlogo.png";
import spWordmark from "../../assets/brand/swletters.png";

export default function ProfileUpdate() {
  const navigate = useNavigate();

  const [phone, setPhone] = useState("");
  const [username, setUsername] = useState("");

  const handleSubmit = () => {
    if (!phone || !username) {
      alert("Please fill in all fields");
      return;
    }

    // TODO: Send API request here
    // await api.updateProfileInfo({ phone, username });

    navigate("/verify/documents");
  };

  return (
    <div className="min-h-screen grid place-items-center bg-[#fff8e1]">
      <div className="w-[412px] [font-family:'Nunito',Helvetica] text-[#5d4037]">

        {/* Centered Logo */}
        <div className="w-full flex justify-center">
          <div className="inline-flex items-center gap-[0px] leading-none">
            <img
              src={spIcon}
              alt="Sweet Plate logo"
              className="shrink-0 select-none object-contain w-[65px] h-[86px] -mt-[2px]"
            />
            <img
              src={spWordmark}
              alt="Sweet Plate"
              className="shrink-0 select-none object-contain h-[29px] w-auto -ml-[4px]"
            />
          </div>
        </div>

        {/* Title */}
        <h1 className="mt-3 ml-6 font-bold text-[22px] leading-7">
          Join Sweet Plate Vendor
        </h1>

        {/* Stepper (Step 1) */}
        <div className="w-[378px] mx-auto mt-3 flex items-center gap-2">
          <div className="w-8 h-8 rounded-full bg-[#5d4037] text-[#fff8e1] grid place-items-center text-sm font-bold">
            1
          </div>
          <div className="flex-1 h-[2px] bg-[#5d4037]/40" />
        </div>

        <div className="w-[378px] mx-auto mt-6">
          <p className="font-extrabold uppercase text-[14px] tracking-wide">
            Profile Information
          </p>
          <p className="mt-1 text-[14px]">Please provide your basic contact details</p>
        </div>

        {/* Form */}
        <div className="w-[378px] mx-auto mt-6 space-y-4">

          {/* Username */}
          <div>
            <label className="text-[14px] font-semibold mb-1 block">
              Username
            </label>
            <input
              type="text"
              placeholder="Enter username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="w-full rounded-[12px] border border-[#5d4037] bg-white p-3 text-[15px] outline-none"
            />
          </div>

          {/* Phone Number */}
          <div>
            <label className="text-[14px] font-semibold mb-1 block">
              Phone Number
            </label>
            <input
              type="tel"
              placeholder="Enter phone number"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              className="w-full rounded-[12px] border border-[#5d4037] bg-white p-3 text-[15px] outline-none"
            />
          </div>

        </div>

        {/* Save & Continue Button */}
        <div className="w-[378px] mx-auto">
          <button
            type="button"
            onClick={handleSubmit}
            className="mt-8 w-[290px] h-[60px] mx-auto block rounded-[50px] bg-[#f7c945] font-bold text-[#5d4037] hover:opacity-90 transition-opacity"
          >
            Save & Continue
          </button>
        </div>

        {/* Back Button */}
        <div className="w-[378px] mx-auto mt-4">
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="mx-auto block text-sm underline text-[#5d4037]"
          >
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
}
